var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	87539: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(6865), __webpack_require__.e(1817), __webpack_require__.e(2260), __webpack_require__.e(2076), __webpack_require__.e(7580)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	46909: {
		fallback: () => (Promise.all([__webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(1516), __webpack_require__.e(3766), __webpack_require__.e(845)]).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=7.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	42777: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(316)]).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	40527: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(2777), __webpack_require__.e(7912)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 87912))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/layout",

	},
	15599: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(2777), __webpack_require__.e(7582), __webpack_require__.e(5642), __webpack_require__.e(8657), __webpack_require__.e(8513)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/a11y",

	},
	65299: {
		fallback: () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(2973)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/coercion",

	},
	70781: {
		fallback: () => (Promise.all([__webpack_require__.e(2777), __webpack_require__.e(2076), __webpack_require__.e(8402)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 17699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/platform",

	},
	25735: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(6865), __webpack_require__.e(2777), __webpack_require__.e(4456)]).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	97582: {
		fallback: () => (Promise.all([__webpack_require__.e(2777), __webpack_require__.e(9291), __webpack_require__.e(4967), __webpack_require__.e(436)]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	76255: {
		fallback: () => (Promise.all([__webpack_require__.e(2645), __webpack_require__.e(1817), __webpack_require__.e(2260), __webpack_require__.e(3895)]).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	79291: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(7354)]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	28707: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(5051), __webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(3277), __webpack_require__.e(7582), __webpack_require__.e(9291), __webpack_require__.e(3840), __webpack_require__.e(9706)]).then(() => (() => (__webpack_require__(/*! @angular/material/icon */ 93840))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/icon",

	},
	14133: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(6255), __webpack_require__.e(1383)]).then(() => (() => (__webpack_require__(/*! @ngrx/store */ 81383))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store",

	},
	45261: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(2777), __webpack_require__.e(7582), __webpack_require__.e(5072)]).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	38019: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(527), __webpack_require__.e(6781), __webpack_require__.e(5599), __webpack_require__.e(5299), __webpack_require__.e(781), __webpack_require__.e(4175), __webpack_require__.e(7690)]).then(() => (() => (__webpack_require__(/*! @angular/material/button */ 84175))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/button",

	},
	66747: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(5051), __webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(3277), __webpack_require__.e(527), __webpack_require__.e(6781), __webpack_require__.e(8203), __webpack_require__.e(5599), __webpack_require__.e(9553), __webpack_require__.e(5299), __webpack_require__.e(781), __webpack_require__.e(4175), __webpack_require__.e(5262)]).then(() => (() => (__webpack_require__(/*! @angular/material/snack-bar */ 3347))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/snack-bar",

	},
	47191: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(527), __webpack_require__.e(1134)]).then(() => (() => (__webpack_require__(/*! @angular/material/progress-spinner */ 41134))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/progress-spinner",

	},
	65903: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3777)]).then(() => (() => (__webpack_require__(/*! @angular/material/card */ 53777))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/card",

	},
	1729: {
		fallback: () => (Promise.all([__webpack_require__.e(2615), __webpack_require__.e(9398), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! @angular/fire/compat */ 48942))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire/compat",

	},
	97355: {
		fallback: () => (Promise.all([__webpack_require__.e(2615), __webpack_require__.e(9398), __webpack_require__.e(2044)]).then(() => (() => (__webpack_require__(/*! @angular/fire/compat/remote-config */ 12044))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire/compat/remote-config",

	},
	32051: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(6781), __webpack_require__.e(489), __webpack_require__.e(284), __webpack_require__.e(762), __webpack_require__.e(4646)]).then(() => (() => (__webpack_require__(/*! @angular/material/core */ 74646))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/core",

	},
	94219: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(489), __webpack_require__.e(8203), __webpack_require__.e(9553), __webpack_require__.e(7485), __webpack_require__.e(5443), __webpack_require__.e(2587)]).then(() => (() => (__webpack_require__(/*! @angular/material/dialog */ 12587))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/dialog",

	},
	40805: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(4102)]).then(() => (() => (__webpack_require__(/*! @angular/material/divider */ 14102))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/divider",

	},
	15901: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(489), __webpack_require__.e(8203), __webpack_require__.e(2805), __webpack_require__.e(9322)]).then(() => (() => (__webpack_require__(/*! @angular/material/expansion */ 19322))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/expansion",

	},
	2103: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(8395), __webpack_require__.e(423), __webpack_require__.e(7389), __webpack_require__.e(9965)]).then(() => (() => (__webpack_require__(/*! @angular/material/form-field */ 24950))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/form-field",

	},
	38467: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3631), __webpack_require__.e(8395), __webpack_require__.e(423), __webpack_require__.e(7389), __webpack_require__.e(7688)]).then(() => (() => (__webpack_require__(/*! @angular/material/input */ 95541))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/input",

	},
	20105: {
		fallback: () => (Promise.all([__webpack_require__.e(4967), __webpack_require__.e(4547), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser/animations */ 43835))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser/animations",

	},
	20239: {
		fallback: () => (__webpack_require__.e(1507).then(() => (() => (__webpack_require__(/*! @ionic/angular */ 21507))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=8.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ionic/angular",

	},
	83970: {
		fallback: () => (__webpack_require__.e(347).then(() => (() => (__webpack_require__(/*! @ngrx/effects */ 70347))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/effects",

	},
	76254: {
		fallback: () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(1903)]).then(() => (() => (__webpack_require__(/*! @ngrx/operators */ 72743))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/operators",

	},
	56583: {
		fallback: () => (__webpack_require__.e(2175).then(() => (() => (__webpack_require__(/*! @ngrx/router-store */ 32175))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/router-store",

	},
	58218: {
		fallback: () => (__webpack_require__.e(1925).then(() => (() => (__webpack_require__(/*! @ngrx/store-devtools */ 11925))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store-devtools",

	},
	56018: {
		fallback: () => (__webpack_require__.e(7756).then(() => (() => (__webpack_require__(/*! @onesource/angular/components/avatar */ 77756))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/angular/components/avatar",

	},
	88386: {
		fallback: () => (__webpack_require__.e(7595).then(() => (() => (__webpack_require__(/*! @onesource/angular/components/button */ 7595))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/angular/components/button",

	},
	58490: {
		fallback: () => (Promise.all([__webpack_require__.e(720), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! @onesource/angular/components/snackbar */ 62722))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/angular/components/snackbar",

	},
	7309: {
		fallback: () => (Promise.all([__webpack_require__.e(7815), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! @sbg/web/deeplink */ 84494))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=6.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@sbg/web/deeplink",

	},
	18983: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @sbg/web/site-config */ 96832))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=6.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@sbg/web/site-config",

	},
	23905: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 8513))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	43137: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 36699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	62013: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(6865), __webpack_require__.e(6255), __webpack_require__.e(2531)]).then(() => (() => (__webpack_require__(/*! @angular/fire */ 12531))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/fire",

	},
	85051: {
		fallback: () => (__webpack_require__.e(1299).then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 63680))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/bidi",

	},
	13277: {
		fallback: () => (__webpack_require__.e(1608).then(() => (() => (__webpack_require__(/*! @angular/cdk/private */ 9227))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/private",

	},
	50489: {
		fallback: () => (__webpack_require__.e(4879).then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 74879))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/keycodes",

	},
	38203: {
		fallback: () => (__webpack_require__.e(9168).then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/portal",

	},
	99553: {
		fallback: () => (Promise.all([__webpack_require__.e(2645), __webpack_require__.e(2777), __webpack_require__.e(9975), __webpack_require__.e(1516), __webpack_require__.e(9168), __webpack_require__.e(8500), __webpack_require__.e(2076), __webpack_require__.e(1567)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/overlay",

	},
	97485: {
		fallback: () => (Promise.all([__webpack_require__.e(2777), __webpack_require__.e(9975), __webpack_require__.e(1419)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 79975))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/scrolling",

	},
	68395: {
		fallback: () => (__webpack_require__.e(5129).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers/private */ 65129))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/observers/private",

	},
	55443: {
		fallback: () => (Promise.all([__webpack_require__.e(2645), __webpack_require__.e(2777), __webpack_require__.e(7582), __webpack_require__.e(9975), __webpack_require__.e(1516), __webpack_require__.e(9168), __webpack_require__.e(8500), __webpack_require__.e(5642), __webpack_require__.e(3482)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/dialog */ 93482))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/dialog",

	},
	82805: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(7989)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 37989))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/collections",

	},
	59933: {
		fallback: () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(3197)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/accordion */ 9180))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/accordion",

	},
	47389: {
		fallback: () => (__webpack_require__.e(1920).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 39539))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/observers",

	},
	43631: {
		fallback: () => (__webpack_require__.e(9940).then(() => (() => (__webpack_require__(/*! @angular/cdk/text-field */ 69940))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/text-field",

	},
	4217: {
		fallback: () => (Promise.all([__webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(2777), __webpack_require__.e(9975), __webpack_require__.e(5969)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/table */ 90198))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/table",

	},
	34053: {
		fallback: () => (Promise.all([__webpack_require__.e(5735), __webpack_require__.e(8657), __webpack_require__.e(4315)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/stepper */ 63985))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/stepper",

	},
	24547: {
		fallback: () => (__webpack_require__.e(655).then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",

	},
	11614: {
		fallback: () => (__webpack_require__.e(8842).then(() => (() => (__webpack_require__(/*! @onesource/angular/components/core */ 28842))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/angular/components/core",

	},
	97940: {
		fallback: () => (Promise.all([__webpack_require__.e(527), __webpack_require__.e(1229), __webpack_require__.e(2444)]).then(() => (() => (__webpack_require__(/*! @onesource/angular/configuration */ 52444))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/angular/configuration",

	},
	30720: {
		fallback: () => (__webpack_require__.e(299).then(() => (() => (__webpack_require__(/*! @onesource/foundation/icons */ 10299))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=3.3.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/foundation/icons",

	},
	21229: {
		fallback: () => (Promise.all([__webpack_require__.e(6909), __webpack_require__.e(5051), __webpack_require__.e(2645), __webpack_require__.e(3277), __webpack_require__.e(6781), __webpack_require__.e(489), __webpack_require__.e(8203), __webpack_require__.e(5599), __webpack_require__.e(9553), __webpack_require__.e(5299), __webpack_require__.e(781), __webpack_require__.e(2805), __webpack_require__.e(7485), __webpack_require__.e(5735), __webpack_require__.e(8395), __webpack_require__.e(423), __webpack_require__.e(284), __webpack_require__.e(7389), __webpack_require__.e(4175), __webpack_require__.e(762), __webpack_require__.e(5575), __webpack_require__.e(5175), __webpack_require__.e(743)]).then(() => (() => (__webpack_require__(/*! @angular/material/paginator */ 24624))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/paginator",

	},
	47815: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @sbg/web/log */ 33798))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=6.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@sbg/web/log",

	},
	39977: {
		fallback: () => (Promise.all([__webpack_require__.e(9975), __webpack_require__.e(854)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/drag-drop */ 50854))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/drag-drop",

	},
	7907: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(6781), __webpack_require__.e(489), __webpack_require__.e(7485), __webpack_require__.e(8395), __webpack_require__.e(423), __webpack_require__.e(284), __webpack_require__.e(762), __webpack_require__.e(9771)]).then(() => (() => (__webpack_require__(/*! @angular/material/autocomplete */ 79771))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/autocomplete",

	},
	77495: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(489), __webpack_require__.e(5443), __webpack_require__.e(5244)]).then(() => (() => (__webpack_require__(/*! @angular/material/bottom-sheet */ 15244))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/bottom-sheet",

	},
	58267: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(6781), __webpack_require__.e(7024)]).then(() => (() => (__webpack_require__(/*! @angular/material/checkbox */ 97024))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/checkbox",

	},
	27201: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(6781), __webpack_require__.e(489), __webpack_require__.e(8395), __webpack_require__.e(423), __webpack_require__.e(2772)]).then(() => (() => (__webpack_require__(/*! @angular/material/chips */ 12772))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/chips",

	},
	50523: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(6781), __webpack_require__.e(489), __webpack_require__.e(7485), __webpack_require__.e(8395), __webpack_require__.e(423), __webpack_require__.e(4175), __webpack_require__.e(5575), __webpack_require__.e(8029)]).then(() => (() => (__webpack_require__(/*! @angular/material/datepicker */ 61977))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/datepicker",

	},
	61555: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(6354)]).then(() => (() => (__webpack_require__(/*! @angular/material/progress-bar */ 26354))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/progress-bar",

	},
	61547: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(6781), __webpack_require__.e(489), __webpack_require__.e(7485), __webpack_require__.e(8395), __webpack_require__.e(423), __webpack_require__.e(284), __webpack_require__.e(7389), __webpack_require__.e(762), __webpack_require__.e(5175)]).then(() => (() => (__webpack_require__(/*! @angular/material/select */ 25175))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/select",

	},
	9792: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(489), __webpack_require__.e(4217), __webpack_require__.e(2047)]).then(() => (() => (__webpack_require__(/*! @angular/material/sort */ 22047))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/sort",

	},
	1989: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(6781), __webpack_require__.e(3840), __webpack_require__.e(6622)]).then(() => (() => (__webpack_require__(/*! @angular/material/stepper */ 56622))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/stepper",

	},
	95971: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(4217), __webpack_require__.e(7697)]).then(() => (() => (__webpack_require__(/*! @angular/material/table */ 77697))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/table",

	},
	57725: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(489), __webpack_require__.e(7485), __webpack_require__.e(5575), __webpack_require__.e(8654)]).then(() => (() => (__webpack_require__(/*! @angular/material/tooltip */ 80640))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/tooltip",

	},
	41721: {
		fallback: () => (__webpack_require__.e(1803).then(() => (() => (__webpack_require__(/*! @ngrx/signals */ 61803))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/signals",

	},
	34386: {
		fallback: () => (__webpack_require__.e(5667).then(() => (() => (__webpack_require__(/*! @onesource/angular/components/info-block */ 55667))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/angular/components/info-block",

	},
	75368: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @onesource/angular/components/spinner */ 71650))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/angular/components/spinner",

	},
	23423: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(6781), __webpack_require__.e(489), __webpack_require__.e(8203), __webpack_require__.e(9553), __webpack_require__.e(7485), __webpack_require__.e(1034)]).then(() => (() => (__webpack_require__(/*! @angular/material/menu */ 31034))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/menu",

	},
	20685: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! @angular/material/toolbar */ 39552))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/toolbar",

	},
	97971: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(489), __webpack_require__.e(7485), __webpack_require__.e(7049)]).then(() => (() => (__webpack_require__(/*! @angular/material/sidenav */ 17049))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/sidenav",

	},
	75677: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(6256)]).then(() => (() => (__webpack_require__(/*! @angular/material/badge */ 16256))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/badge",

	},
	70763: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(6781), __webpack_require__.e(489), __webpack_require__.e(284), __webpack_require__.e(7389), __webpack_require__.e(943)]).then(() => (() => (__webpack_require__(/*! @angular/material/list */ 20943))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/list",

	},
	58315: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @ngrx/signals/rxjs-interop */ 8275))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/signals/rxjs-interop",

	},
	92897: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(6781), __webpack_require__.e(3804)]).then(() => (() => (__webpack_require__(/*! @angular/material/radio */ 53804))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/radio",

	},
	4233: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(6781), __webpack_require__.e(489), __webpack_require__.e(284), __webpack_require__.e(9864)]).then(() => (() => (__webpack_require__(/*! @angular/material/button-toggle */ 59864))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/button-toggle",

	},
	14631: {
		fallback: () => (__webpack_require__.e(7172).then(() => (() => (__webpack_require__(/*! @angular/animations */ 47172))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations",

	},
	80291: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(6781), __webpack_require__.e(489), __webpack_require__.e(7485), __webpack_require__.e(8395), __webpack_require__.e(7389), __webpack_require__.e(8223)]).then(() => (() => (__webpack_require__(/*! @angular/material/tabs */ 38223))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/tabs",

	},
	71327: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @sbg/web/event */ 74372))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=6.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@sbg/web/event",

	},
	22627: {
		fallback: () => (Promise.all([__webpack_require__.e(5051), __webpack_require__.e(3277), __webpack_require__.e(6781), __webpack_require__.e(8827)]).then(() => (() => (__webpack_require__(/*! @angular/material/slide-toggle */ 8827))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=20.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/slide-toggle",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"27": [
		14631
	],
	"207": [
		39977,
		7907,
		77495,
		58267,
		27201,
		50523,
		61555,
		61547,
		9792,
		1989,
		95971,
		57725,
		41721,
		34386,
		75368
	],
	"291": [
		80291
	],
	"489": [
		50489
	],
	"527": [
		40527
	],
	"720": [
		30720
	],
	"781": [
		70781
	],
	"1229": [
		21229
	],
	"1665": [
		20685
	],
	"1729": [
		1729
	],
	"2260": [
		23905,
		43137
	],
	"2468": [
		22627
	],
	"2777": [
		42777
	],
	"2805": [
		82805
	],
	"2897": [
		92897
	],
	"3277": [
		13277
	],
	"3317": [
		97355,
		32051,
		94219,
		40805,
		15901,
		2103,
		38467,
		20105,
		20239,
		83970,
		76254,
		56583,
		58218,
		56018,
		88386,
		58490,
		7309,
		18983
	],
	"3423": [
		23423
	],
	"3631": [
		43631
	],
	"4133": [
		14133
	],
	"4217": [
		4217
	],
	"4233": [
		4233
	],
	"4547": [
		24547
	],
	"5051": [
		85051
	],
	"5261": [
		45261
	],
	"5299": [
		65299
	],
	"5443": [
		55443
	],
	"5599": [
		15599
	],
	"5677": [
		75677
	],
	"5735": [
		25735
	],
	"5903": [
		65903
	],
	"6255": [
		76255
	],
	"6622": [
		34053
	],
	"6747": [
		66747
	],
	"6779": [
		70763
	],
	"6909": [
		46909
	],
	"7191": [
		47191
	],
	"7389": [
		47389
	],
	"7485": [
		97485
	],
	"7539": [
		87539
	],
	"7582": [
		97582
	],
	"7595": [
		97940
	],
	"7756": [
		11614
	],
	"7815": [
		47815
	],
	"7971": [
		97971
	],
	"8019": [
		38019
	],
	"8203": [
		38203
	],
	"8315": [
		58315
	],
	"8395": [
		68395
	],
	"8707": [
		28707
	],
	"9128": [
		71327
	],
	"9291": [
		79291
	],
	"9322": [
		59933
	],
	"9398": [
		62013
	],
	"9553": [
		99553
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}